import { render } from "./EditProfile.vue?vue&type=template&id=faf971f2&scoped=true&ts=true"
import script from "./EditProfile.vue?vue&type=script&lang=ts"
export * from "./EditProfile.vue?vue&type=script&lang=ts"

import "./EditProfile.vue?vue&type=style&index=0&id=faf971f2&lan=scss&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faf971f2"]])

export default __exports__